import { createApi } from '@reduxjs/toolkit/query/react';

import axiosBaseQuery from 'utils/base-api';
import {
  CreateWorkerOrderFromCrm,
  DepartmentCTApp,
  DepartmentCTAppResponse,
  DirectCommander, DirectlyCommander,
  ResponseDto
} from '../../types';

export const constructionSiteManagement = createApi({
  reducerPath: 'constructionSiteManagement',
  baseQuery: axiosBaseQuery,
  endpoints: (builder) => ({
    getAppCtDepartments: builder.query<DepartmentCTAppResponse, null>({
      query: () => ({
        url: "/appct_integration/appct_departments",
        method: 'GET'
      })
    }),

    getDirectCommanders: builder.query<DirectCommander, string>({
      query: (departmentCode) => ({
        url: `/appct_integration/direct_commanders/${departmentCode}`,
        method: 'GET'
      })
    }),

    getWorkers: builder.query<Worker, string>({
      query: (departmentCode) => ({
        url: `/appct_integration/workers/${departmentCode}`,
        method: 'GET'
      })
    }),

    getCommanderByTicketId: builder.query<ResponseDto<DirectlyCommander[]>, number>({
      query: (ticketId) => ({
        url: `/appct_integration/direct_commander_by_ticket_id/${ticketId}`,
        method: 'GET'
      })
    }),

    postCreateWorkerOrderFromCrm: builder.mutation<ResponseDto<string>, CreateWorkerOrderFromCrm>({
      query: (request) => ({
        url: '/appct_integration/create_work_order_from_CRM',
        method: 'POST',
        data: request
      })
    })
  })
});

export const {
  useGetAppCtDepartmentsQuery,
  useLazyGetDirectCommandersQuery,
  useLazyGetWorkersQuery,

  useGetCommanderByTicketIdQuery,
  useLazyGetCommanderByTicketIdQuery,

  usePostCreateWorkerOrderFromCrmMutation,
} = constructionSiteManagement;
